import uploadshomefeaturesSpecializefeature01ImagethreePeopleWalkingJpg from "$lib/data/generated/uploads/home/Features Specialize/Feature 01 Image/Three People Walking.jpg";

export const uploads = {
  "uploads/home/Features Specialize/Feature 01 Image/Three People Walking.jpg": uploadshomefeaturesSpecializefeature01ImagethreePeopleWalkingJpg
};